import React from "react";
import {
  Typography,
  Button,
  Box,
  Stack,
  Paper,
  Grid,
  Container,
} from "@mui/material";
import { Link } from "react-router-dom";
import PricingCalculator from "./PricingCalculator";

const valueProps = [
  "Pay per a client, not per a bucket",
  "Monthly billing, cancel anytime",
  "Handle payments for $10/month flat",
  "No contracts, no hidden fees",
];

const trialFeatures = [
  "Unlimited Slots",
  "White Glove Service",
  "Onboarding Call",
  "Import Programs",
];

const Pricing = () => {
  return (
    <Box
      sx={{
        bgcolor: "#fff",
        color: "#111",
        minHeight: "calc(100vh - 64px)",
      }}
    >
      <Container maxWidth="lg" sx={{ py: { xs: 3, md: 5 } }}>
        <Paper
          variant="outlined"
          sx={{
            p: { xs: 2.5, md: 3 },
            mb: { xs: 3, md: 6 },
            bgcolor: "#fff",
            boxShadow: "4px 6px 0 rgba(0,0,0,0.08)",
            borderColor: "rgba(0,0,0,0.05)",
          }}
        >
          <Grid container spacing={{ xs: 3, md: 4 }} alignItems="center">
            <Grid item xs={12} md={7}>
              <Typography
                component="h1"
                sx={{
                  fontSize: { xs: "1.8rem", md: "2rem" },
                  fontWeight: 900,
                  mb: 1.5,
                }}
              >
                Simple Pricing.
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "1rem", md: "1.1rem" },
                  lineHeight: 1.45,
                  maxWidth: 680,
                  mb: 2.5,
                }}
              >
                Everything you need to coach clients and run your business -
                without the bloat, hidden fees, or complicated add-ons.
              </Typography>
              <Grid container spacing={1.5}>
                {valueProps.map((item, index) => (
                  <Grid item xs={12} sm={6} key={item}>
                    <Stack direction="row" spacing={1.5}>
                      <Typography sx={{ fontWeight: 700 }}>
                        {index + 1}.
                      </Typography>
                      <Typography>{item}</Typography>
                    </Stack>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  textAlign: { xs: "left", md: "center" },
                  px: { xs: 0, md: 2 },
                }}
              >
                <Typography
                  sx={{
                    color: "#ef0000",
                    fontWeight: 900,
                    fontSize: "1.25rem",
                    mb: 2,
                  }}
                >
                  1 Month Free Trial
                </Typography>
                <Stack
                  spacing={0.8}
                  sx={{
                    alignItems: { xs: "flex-start", md: "center" },
                    mb: 2,
                  }}
                >
                  {trialFeatures.map((feature) => (
                    <Typography key={feature} sx={{ fontWeight: 700 }}>
                      - {feature}
                    </Typography>
                  ))}
                </Stack>
                <Button
                  component={Link}
                  to="/coaching"
                  variant="contained"
                  color="primary"
                  sx={{
                    fontWeight: 900,
                    px: 3,
                  }}
                >
                  Sign Up Today!
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Paper>

        <Grid container spacing={3} sx={{ pb: { xs: 3, md: 7 } }}>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                height: "100%",
                "& > .MuiPaper-root": {
                  height: "100%",
                  mb: 0,
                },
              }}
            >
              <PricingCalculator />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper
              variant="outlined"
              sx={{
                p: { xs: 3, md: 4 },
                height: "100%",
                bgcolor: "#fff",
                boxShadow: "5px 6px 0 rgba(0,0,0,0.08)",
                borderColor: "rgba(0,0,0,0.05)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography
                component="h2"
                sx={{
                  fontSize: { xs: "1.8rem", md: "2.3rem" },
                  fontWeight: 900,
                  lineHeight: 1,
                  mb: 2,
                }}
              >
                Sign up now.
              </Typography>
              <Typography sx={{ fontSize: "1.05rem", lineHeight: 1.5, mb: 3 }}>
                Start with a free month, get white glove onboarding, and bring
                your clients into a simpler coaching workflow.
              </Typography>
              <Button
                component={Link}
                to="/coaching"
                variant="contained"
                color="primary"
                sx={{
                  fontWeight: 900,
                  alignSelf: "flex-start",
                  px: 3,
                }}
              >
                Start Free Trial
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Pricing;
